import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Button,
} from "reactstrap";
import { useLazyQuery, useQuery } from "@apollo/client";
import {
  GET_ALL_CONTATCTS,
  GET_CONTACT_LIST_QUERY,
} from "../Graphql/ContactsQueries/contactsQuery";
import {
  FaPhone,
  FaEnvelope,
  FaRegAddressCard,
  FaBuilding,
  FaCity,
  FaMapMarkedAlt,
  FaMapPin
} from "react-icons/fa";
import Icon from "../Icon/Icon";
import { Link } from "react-router";
import svgEdit from "../../svgs/edit.svg";
import svgSortAsc from "../../svgs/arrow-up.svg";
import Alert from "../Alert/Alert";
import MergeIcon from "@mui/icons-material/Merge";
import StarIcon from '@mui/icons-material/Star'; // filled star
import StarBorderIcon from '@mui/icons-material/StarBorder'; // outlined star
import { IconButton } from "@mui/material";
import { UserContext } from "../Root/Root";

const Contacts = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [currentIndex, setCurrentIndex] = useState({
    Agent: 0,
    // Seller: 0,
    // Buyer: 0,
    "Team-Members": 0,
    Tenant: 0,
    Lender: 0,
    Investor: 0,
    Vendor: 0
  });
  const [showAll, setShowAll] = useState({ agents: false, sellers: false });
  const [currentPage, setCurrentPage] = useState(1);
  const [contactsData, setContactsData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const token = localStorage.getItem("authToken");
  const [isLoadingCategory, setIsLoadingCategory] = useState(true);
  const [selectedLetter, setSelectedLetter] = useState(null);
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  const [hotlist, setHotList] = useState(false)
  const user = useContext(UserContext);
  const loginUserIdData = hotlist && user && user.userData ? user.userData.id.toString() : null
  useEffect(() => {
    // Dynamically load Bootstrap CSS
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css";
    document.head.appendChild(link);

    return () => {
      // Remove Bootstrap CSS when the component unmounts
      document.head.removeChild(link);
    };
  }, []);

  const { loading, error, data, refetch } = useQuery(GET_ALL_CONTATCTS, {
    variables: { limit: 12 }, // Adjust the limit if necessary
    fetchPolicy: "no-cache",
    context: {
      headers: {
        authorization: `Bearer ${token}`,
      },
    },
  });

  const [fetchContactsByType, { loading: typeLoading, error: typeError }] =
    useLazyQuery(GET_CONTACT_LIST_QUERY, {
      fetchPolicy: "no-cache",
      context: {
        headers: {
          authorization: `Bearer ${token}`,
        },
      },
      onCompleted: (fetchedData) => {
        setContactsData(fetchedData.getContacts.data);
        setTotalCount(fetchedData.getContacts.totalCount);
        setIsLoadingCategory(false); // Stop spinner
      },
    });

  useEffect(() => {
    const handleBackNavigation = () => {
      if (window.location.pathname === "/contacts") {
        refetch(); // Fetch updated data when user navigates back to Grid View
      }
    };

    window.addEventListener("popstate", handleBackNavigation);

    return () => {
      window.removeEventListener("popstate", handleBackNavigation);
    };
  }, [refetch]);

  const handleHotListStar = () => {
    setHotList((prev) => !prev);
  };


  useEffect(() => {
    if (selectedCategory !== "All") {
      fetchContactsByType({
        variables: {
          type: selectedCategory && selectedCategory === "Team-Members" ? "Team" : selectedCategory,
          startsWith: selectedLetter,
          loginUserId: loginUserIdData,
          pageOptions: {
            page: currentPage,
            pageSize: 52,
          },
        },
      });
    }
  }, [selectedCategory, currentPage, selectedLetter, loginUserIdData]);

  const handleroledexButton = (category) => {
    setSelectedCategory(category)
  }
  const handleDropdownChange = (event) => {
    setSelectedLetter(null);
    setHotList(false)
    setIsLoadingCategory(true);
    setSelectedCategory(
      event.target.value != "Team-Members" ? event.target.value : "Team"
    );
    setCurrentPage(1); // Reset page number on category change
  };
  const handleLetterClick = (letter) => {
    if (letter === selectedLetter) {
      setSelectedLetter(null);
    } else {
      setSelectedLetter(letter);
    }
    setCurrentPage(1);
    // if(currentPage === 1){
    //   fetchContactsByType({
    //     variables: {
    //       type: selectedCategory,
    //       startsWith:letter === selectedLetter? null :letter,
    //       pageOptions: {
    //         page: 1,
    //         pageSize: 52,
    //       },
    //     },
    //   });
    // }
  };
  const handleNavigation = (type, direction) => {
    const maxIndex =
      Math.ceil(
        ((data.getAllContacts[type != "Team-Members" ? type + "s" : "Teams"] &&
          data.getAllContacts[type != "Team-Members" ? type + "s" : "Teams"]
            .length) ||
          0) / 4
      ) - 1;
    setCurrentIndex((prev) => {
      const nextIndex =
        direction === "next"
          ? Math.min(prev[type] + 1, maxIndex)
          : Math.max(prev[type] - 1, 0);
      return { ...prev, [type]: nextIndex };
    });
  };

  const handleShowMore = (type) => {
    // setShowAll((prev) => ({ ...prev, [type]: true }));
    // setSelectedCategory(`${type}-list`);
    setSelectedCategory(type);
    setCurrentPage(1);
  };

  // New method for pagination when selectedCategory !== "All"
  const handlePageChange = (direction) => {
    setCurrentPage((prevPage) =>
      direction === "next" ? prevPage + 1 : Math.max(prevPage - 1, 1)
    );
  };

  const handleListView = (type) => {
    const urlType = new Set(["team", "team-members"]).has(type.toLowerCase())
      ? "team-members"
      : type.toLowerCase() + "s";
    const url = `${location.origin}/contacts/${urlType}`;
    window.location.href = url;
    sessionStorage.setItem("isCrm", "true");
  };

  const getAddress = (item) => {
    return item.address || item.company_address || "N/A";
  };

  const renderCards = (data, type) => {
    const start = currentIndex[type] * 4;
    const end = showAll[type] ? data.length : start + 4;
    // const urlType = type.toLowerCase() === "team-members" ? "teamMember" : type.toLowerCase();
    const urlType = new Set(["team", "team-members"]).has(type.toLowerCase())
      ? "teamMember"
      : type.toLowerCase();
    const visibleCards = data.slice(start, end);
    const currentSearch = window.location.search;
    const currentPath = window.location.pathname + currentSearch;
    return (
      <Row className="mb-3">
        {visibleCards.map((item, index) => (
          <Col sm="3" key={`${type}-${index}`}>
            <Card>
              <CardHeader
                style={{ borderBlockColor: "#90C54B", color: "green" }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span
                    title={
                      item.first_name && item.last_name
                        ? `${item.first_name} ${item.last_name}`
                        : item.first_name
                          ? item.first_name
                          : item.last_name
                            ? item.last_name
                            : item.name
                              ? item.name
                              : item.contact_name
                                ? item.contact_name
                                : "N/A"
                    }
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "70%",
                    }}
                  >
                    {item.first_name && item.last_name
                      ? `${item.first_name} ${item.last_name}`
                      : item.first_name
                        ? item.first_name
                        : item.last_name
                          ? item.last_name
                          : item.name
                            ? item.name
                            : item.contact_name
                              ? item.contact_name
                              : "N/A"}
                  </span>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    {type !== "Team-Members" && type !== "Team" && <Link
                      to={{
                        pathname: `${arc.path.base}merging/contacts/${item.first_name} ${item.last_name}`,
                      }}
                      style={{
                        cursor: "pointer",
                        fontSize: "20px",
                        color: "rgb(100, 100, 100)",
                        backgroundColor: "transparent",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        textDecoration: "none",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget
                          .querySelectorAll("svg path")
                          .forEach((path) => {
                            path.setAttribute("fill", "#90c54b");
                          });
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget
                          .querySelectorAll("svg path")
                          .forEach((path) => {
                            path.setAttribute("fill", "#939393");
                          });
                      }}
                    >
                      <MergeIcon />
                    </Link>}
                    <Link
                      to={{
                        // pathname: `${arc.path.base}${urlType}/${item.contact_id}`,
                        pathname: `${arc.path.base}${urlType}/${item.contact_id}`,
                        state: { fromListUrl: currentPath }
                      }}
                      style={{
                        cursor: "pointer",
                        fontSize: "20px",
                        color: "rgb(100, 100, 100)",
                        backgroundColor: "transparent",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        textDecoration: "none",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget
                          .querySelector("svg path:nth-child(2)")
                          .setAttribute("fill", "#90c54b");
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget
                          .querySelector("svg path:nth-child(2)")
                          .setAttribute("fill", "#939393");
                      }}
                    >
                      <Icon svg={svgEdit} />
                    </Link>
                  </div>
                </div>
              </CardHeader>
              <CardBody style={{ height: "auto", padding: "12px" }}>
                {/* Phone */}
                <p style={{ display: "flex", alignItems: "center", margin: "3px 0", lineHeight: "1.2" }}>
                  <FaPhone
                    style={{
                      marginRight: "6px",
                      transform: "rotate(90deg)",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  />
                  <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "85%" }}>
                    {item.phone || item.contact_phone || "N/A"}
                  </span>
                </p>

                {/* Email */}
                <p style={{ display: "flex", alignItems: "center", margin: "3px 0", lineHeight: "1.2" }}>
                  <FaEnvelope
                    style={{
                      marginRight: "6px",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  />
                  <span title={item.contact_email || item.email || "N/A"} style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "85%" }}>
                    {item.email || item.contact_email || "N/A"}
                  </span>
                </p>

                {/* Company Name */}
                <p style={{ display: "flex", margin: "10px 0", lineHeight: "1.2" }}>
                  <FaBuilding
                    style={{
                      marginTop: "3px",
                      marginRight: "6px",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  />
                  <span style={{ display: "inline-block", maxWidth: "85%" }}>
                    <span
                      title={item.company_name || "N/A"}
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "85%",
                      }}
                    >
                      {(item.company_name && item.company_name.length > 25)
                        ? item.company_name.slice(0, 25) + "..."
                        : item.company_name || "N/A"}
                    </span>
                    <span
                      title={getAddress(item)}
                      style={{
                        display: "block",
                        color: "#555",
                        fontSize: "14px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap" // <- this ensures the ellipsis works
                      }}
                    >
                      {(getAddress(item).length > 25)
                        ? getAddress(item).slice(0, 25) + "..."
                        : getAddress(item)
                      }
                    </span>
                    <span style={{ display: "block", color: "#555", fontSize: "14px" }}>
                      {(item.company_city || "N/A")}, {(item.company_state || "N/A")}{" "}
                      {(item.company_zip || "N/A")}
                    </span>
                  </span>
                </p>

                {/* Address */}
                {/* <p style={{ display: "flex", alignItems: "center", margin: "3px 0", lineHeight: "1.2" }}>
                  <FaRegAddressCard
                    style={{
                      marginRight: "6px",
                      fontSize: "14px",
                      color: "gray",
                      verticalAlign: "top"
                    }}
                  />
                  <span style={{ display: "inline-block", maxWidth: "85%" }}>
                  <span
                    title={getAddress(item)}
                    style={{
                      // display: "block",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "85%",
                    }}
                  >
                    {(getAddress(item).length > 25)
                      ? getAddress(item).slice(0, 25) + "..."
                      : getAddress(item)
                      }
                  </span>
                    <span style={{ display: "block", color: "#555", fontSize: "13px" }}>
                      {(item.company_city || "N/A")}, {(item.company_state || "N/A")}{" "}
                      {(item.company_zip || "N/A")}
                    </span>
                  </span>
                </p> */}



                {/* Company City */}
                {/* <p style={{ display: "flex", alignItems: "center", margin: "3px 0", lineHeight: "1.2" }}>
                  <FaCity
                    style={{
                      marginRight: "6px",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  />
                  <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "85%" }}>
                    {item.company_city || "N/A"}
                  </span>
                </p> */}

                {/* Company State */}
                {/* <p style={{ display: "flex", alignItems: "center", margin: "3px 0", lineHeight: "1.2" }}>
                  <FaMapMarkedAlt
                    style={{
                      marginRight: "6px",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  />
                  <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "85%" }}>
                    {item.company_state || "N/A"}
                  </span>
                </p> */}

                {/* Company Zip */}
                {/* <p style={{ display: "flex", alignItems: "center", margin: "3px 0", lineHeight: "1.2" }}>
                  <FaMapPin
                    style={{
                      marginRight: "6px",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  />
                  <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "85%" }}>
                    {item.company_zip || "N/A"}
                  </span>
                </p> */}
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    );
  };

  const renderAllCards = (data, type) => {
    // const start = currentIndex[type] * 4;
    // const end = showAll[type] ? data.length : start + 4;

    // const visibleCards = data.slice(start, end);

    // const urlType = type.toLowerCase() === "team-members" ? "teamMember" : type.toLowerCase();
    const urlType = new Set(["team", "team-members"]).has(type.toLowerCase())
      ? "teamMember"
      : type.toLowerCase();

      const currentSearch = window.location.search;
      const currentPath = window.location.pathname + currentSearch;
    if (isLoadingCategory) {
      return (
        <div
          className="spinner-border text-success"
          role="status"
          style={{ marginLeft: "16px" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      );
    }

    if (data.length === 0) {
      return (
        <div className="errorcenter">
          <Alert type="error">No contacts found for {type}.</Alert>
        </div>
      );
    }
    // setIsLoadingCategory(false)
    return (
      <Card style={{ padding: "16px", marginTop: "16px", marginLeft: "16px" }}>
        <div>
          <Row className="mb-3" style={{ margin: "8px" }}>
            {data.map((item, index) => (
              <Col sm="3" key={`${type}-${index}`} style={{ padding: "8px" }}>
                <Card>
                  <CardHeader style={{ background: "#90C54B", color: "white" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span
                        title={
                          item.first_name && item.last_name
                            ? `${item.first_name} ${item.last_name}`
                            : item.first_name
                              ? item.first_name
                              : item.last_name
                                ? item.last_name
                                : item.name
                                  ? item.name
                                  : item.contact_name
                                    ? item.contact_name
                                    : "N/A"
                        }
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "70%", // Adjust based on your design
                        }}
                      >
                        {item.first_name && item.last_name
                          ? `${item.first_name} ${item.last_name}`
                          : item.first_name
                            ? item.first_name
                            : item.last_name
                              ? item.last_name
                              : item.name
                                ? item.name
                                : item.contact_name
                                  ? item.contact_name
                                  : "N/A"}
                      </span>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        {type !== "Team-Members" && type !== "Team" && <Link
                          to={{
                            pathname: `${arc.path.base}merging/contacts/${item.first_name} ${item.last_name}`,
                          }}
                          style={{
                            cursor: "pointer",
                            fontSize: "20px",
                            color: "rgb(100, 100, 100)",
                            backgroundColor: "transparent",
                            border: "none",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            textDecoration: "none",
                          }}
                        >
                          <MergeIcon />
                        </Link>}
                        <Link
                          to={{
                            // pathname: `${arc.path.base}${urlType}/${item.contact_id}`,
                            pathname: `${arc.path.base}${urlType}/${item.contact_id}`,
                            state: { fromListUrl: currentPath }
                          }}
                          style={{
                            cursor: "pointer",
                            fontSize: "20px",
                            color: "rgb(100, 100, 100)",
                            backgroundColor: "transparent",
                            border: "none",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            textDecoration: "none",
                          }}
                        >
                          <Icon svg={svgEdit} />
                        </Link>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody style={{ height: "auto", paddingRight: "12px" }}>
                    {/* Phone */}
                    <p style={{ display: "flex", alignItems: "center", margin: "3px 0", lineHeight: "1.2" }}>
                      <FaPhone
                        style={{
                          marginRight: "6px",
                          transform: "rotate(90deg)",
                          fontSize: "14px",
                          color: "gray",
                        }}
                      />
                      {item.phone || item.contact_phone || "N/A"}
                    </p>

                    {/* Email */}
                    <p
                      title={item.email || item.contact_email || "N/A"}
                      style={{ display: "flex", alignItems: "center", margin: "3px 0", lineHeight: "1.2" }}
                    >
                      <FaEnvelope
                        style={{
                          marginRight: "6px",
                          fontSize: "14px",
                          color: "gray",
                        }}
                      />
                      <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "85%" }}>
                      {item.email || item.contact_email || "N/A"}
                      </span>
                    </p>

                    {/* Company Name */}
                    {/* <p style={{ display: "flex", alignItems: "center", margin: "3px 0", lineHeight: "1.2" }}>
                      <FaBuilding
                        style={{
                          marginRight: "6px",
                          fontSize: "14px",
                          color: "gray",
                        }}
                      />
                      <span
                        title={item.company_name || "N/A"}
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "85%",
                        }}
                      >
                        {item.company_name && item.company_name.length > 25
                          ? item.company_name.slice(0, 25) + "..."
                          : item.company_name || "N/A"}
                      </span>
                    </p> */}
                    <p style={{ display: "flex", margin: "10px 0", lineHeight: "1.2" }}>
                      <FaBuilding
                        style={{
                          marginTop: "3px",
                          marginRight: "6px",
                          fontSize: "14px",
                          color: "gray",
                        }}
                      />
                      <span style={{ display: "inline-block", maxWidth: "85%" }}>
                        <span
                          title={item.company_name || "N/A"}
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "85%",
                          }}
                        >
                          {(item.company_name && item.company_name.length > 25)
                            ? item.company_name.slice(0, 25) + "..."
                            : item.company_name || "N/A"}
                        </span>
                        <span
                          title={getAddress(item)}
                          style={{
                            display: "block",
                            color: "#555",
                            fontSize: "14px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap" // <- this ensures the ellipsis works
                          }}
                        >
                          {(getAddress(item).length > 25)
                            ? getAddress(item).slice(0, 25) + "..."
                            : getAddress(item)
                          }
                        </span>
                        <span style={{ display: "block", color: "#555", fontSize: "14px" }}>
                          {(item.company_city || "N/A")}, {(item.company_state || "N/A")}{" "}
                          {(item.company_zip || "N/A")}
                        </span>
                      </span>
                    </p>

                    {/* Address */}
                    {/* <p style={{ display: "flex", alignItems: "center", margin: "3px 0", lineHeight: "1.2" }}>
                      <FaRegAddressCard
                        style={{
                          marginRight: "6px",
                          fontSize: "14px",
                          color: "gray",
                        }}
                      />
                      <span
                        title={getAddress(item)}
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "85%",
                        }}
                      >
                        {getAddress(item).length > 25
                          ? getAddress(item).slice(0, 25) + "..."
                          : getAddress(item)}
                      </span>
                    </p> */}

                    {/* Company City */}
                    {/* <p style={{ display: "flex", alignItems: "center", margin: "3px 0", lineHeight: "1.2" }}>
                      <FaCity
                        style={{
                          marginRight: "6px",
                          fontSize: "14px",
                          color: "gray",
                        }}
                      />
                      {item.company_city || "N/A"}
                    </p> */}

                    {/* Company State */}
                    {/* <p style={{ display: "flex", alignItems: "center", margin: "3px 0", lineHeight: "1.2" }}>
                      <FaMapMarkedAlt
                        style={{
                          marginRight: "6px",
                          fontSize: "14px",
                          color: "gray",
                        }}
                      />
                      {item.company_state || "N/A"}
                    </p> */}

                    {/* Company Zip */}
                    {/* <p style={{ display: "flex", alignItems: "center", margin: "3px 0", lineHeight: "1.2" }}>
                      <FaMapPin
                        style={{
                          marginRight: "6px",
                          fontSize: "14px",
                          color: "gray",
                        }}
                      />
                      {item.company_zip || "N/A"}
                    </p> */}
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
          {selectedCategory !== "All" && (
            <div
              style={{
                marginTop: "8px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ display: "flex", gap: "8px", marginLeft: "16px" }}>
                {/* <div className="d-flex justify-content-between"> */}
                {/* <Button
              onClick={() => handlePageChange("prev")}
              disabled={currentPage === 1}
              style={{ backgroundColor: "#90C54B" }}
            >
              Previous
            </Button>
            <Button
              onClick={() => handlePageChange("next")}
              disabled={contactsData.length < 52} // Disable next if fewer than pageSize results
              style={{ backgroundColor: "#90C54B" }}
            >
              Next
            </Button> */}
                <button
                  className="button-new negative"
                  onClick={() => handlePageChange("prev")}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                <button
                  className="button-new positive"
                  onClick={() => handlePageChange("next")}
                  disabled={contactsData.length < 52}
                >
                  Next
                </button>
                {/* <span style={{marginTop:"7px"}}>
                Showing <strong>{currentPage == 1 ? currentPage + "-" + 52 : (((currentPage - 1)*52 + 1 )+ "-" +(currentPage) *52)}</strong> of{" "}
                <strong>{totalCount}</strong>
              </span> */}
                <span style={{ marginTop: "7px" }}>
                  Showing{" "}
                  <strong>
                    {currentPage === 1
                      ? `1-${Math.min(52, totalCount)}`
                      : `${(currentPage - 1) * 52 + 1}-${Math.min(
                        currentPage * 52,
                        totalCount
                      )}`}
                  </strong>{" "}
                  of <strong>{totalCount}</strong>
                </span>
              </div>
            </div>
          )}
        </div>
      </Card>
    );
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#fff",
        }}
      >
        <div
          className="spinner-border text-success"
          role="status"
          style={{ marginTop: "23%" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error)
    return (
      <div className="errorcenter">
        <Alert type="error">Error:{error.message}</Alert>
      </div>
    );

  const apiData = {
    Investor: data.getAllContacts.Investors || [],
    Agent: data.getAllContacts.Agents || [],
    // Seller: data.getAllContacts.Sellers || [],
    // Buyer: data.getAllContacts.Buyers || [],
    Vendor: data.getAllContacts.Vendors || [],
    Tenant: data.getAllContacts.Tenants || [],
    "Team-Members": data.getAllContacts.Teams || [],
    Lender: data.getAllContacts.Lenders || [],
  };
  const handleBackClick = () => {
    setSelectedLetter(null);
    setHotList(false)
    if (selectedCategory !== "All") {
      setSelectedCategory("All");
    } else if (selectedCategory === "All") {
      return;
    } else {
      history.back();
    }
  };
  return (
    <div className="CRUD">
      <div className="CRUD_content">
        <div
          className="d-flex"
          style={{ position: "relative", justifyContent: "space-between" }}
        >
          {/* <div className="page-title" style={{ marginLeft: "40px" }}>
              Contacts
            </div> */}
          <div
            className="page-back-button"
            style={{
              padding: "20px",
              marginLeft: "26px",
              color: selectedCategory === "All" ? "black" : "#90C54B",
              fontSize: "1.25rem",
            }}
            onClick={handleBackClick}
          >
            {selectedCategory === "All" ? "" : <Icon svg={svgSortAsc} />}
            Contacts
            <button
              className="button-new positive"
              style={{
                width: "auto",
                marginLeft: "26px",
                padding: "8px 16px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
              onClick={() =>
                (window.location.href = `${location.origin}/merging/contacts`)
              }
            >
              <MergeIcon />
              <span>Merge Duplicate</span>
            </button>
          </div>
          {selectedCategory !== "All" && (
            <div className="" style={{ padding: "20px 35px 0px" }}>
              <select
                className="select-sampletable"
                onChange={handleDropdownChange}
                value={
                  selectedCategory == "Team" ? "Team-Members" : selectedCategory
                }
                style={{ cursor: "pointer" }}
              >
                <option value="All">All</option>
                {Object.keys(apiData).map((category) => (
                  <option key={category} value={category}>
                    {(() => {
                      let label = category.replace(/[_-]/g, " ").trim();

                      // Add 's' if it doesn't already end with 's'
                      if (!label.toLowerCase().endsWith("s")) {
                        label += "s";
                      }

                      // Convert to Title Case
                      return label
                        .toLowerCase()
                        .replace(/\b\w/g, (char) => char.toUpperCase());
                    })()}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
        <div className="page-header-container list" style={{ padding: "0px" }}>
          <div className="line" />
        </div>
        <div className="page-body-container crud">
          <Container style={{ marginLeft: "-25px", maxWidth: "1245px" }}>
            {selectedCategory === "All" ? (
              <Card
                style={{
                  padding: "16px",
                  marginTop: "16px",
                  marginLeft: "16px",
                }}
              >
                {Object.keys(apiData).map((category) => (
                  <div key={category}>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <h5 className="me-3">
                          {(() => {
                            let label = category.replace(/[_-]/g, " ").trim();
                            if (!label.toLowerCase().endsWith("s")) {
                              label += "s";
                            }
                            return label.toUpperCase();
                          })()}
                        </h5>
                        <Button
                          // className="button-new positive"
                          style={{
                            width: "76px",
                            padding: "2px",
                            marginBottom: "0.5rem",
                            backgroundColor: "#90C54B",
                            transition: "box-shadow 0.3s ease-in-out", // Smooth transition for hover effect
                          }}
                          onMouseEnter={(e) =>
                          (e.target.style.boxShadow =
                            "0 4px 8px rgba(0, 0, 0, 0.2)")
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.boxShadow = "none")
                          }
                          onClick={() => handleListView(category)}
                        >
                          List View
                        </Button>
                        <Button
                          // className="button-new positive"
                          style={{
                            marginBottom: "7px",
                            width: "76px",
                            padding: "2px",
                            marginLeft: "8px",
                            marginRight: "16px", // Adjust this if needed
                            // marginBottom: "-0.5rem",
                            backgroundColor: "#90C54B",
                            transition: "box-shadow 0.3s ease-in-out", // Smooth transition for hover effect
                          }}
                          onMouseEnter={(e) =>
                          (e.target.style.boxShadow =
                            "0 4px 8px rgba(0, 0, 0, 0.2)")
                          }
                          onMouseLeave={(e) => (e.target.style.boxShadow = "none")}
                          onClick={() => handleroledexButton(category)}
                        >
                          Roledex
                        </Button>
                      </div>
                      <div style={{ marginBottom: "3.5px" }}>
                        <Button
                          style={{
                            backgroundColor: "#90C54B",
                            marginRight: "1px",
                            transition: "box-shadow 0.3s ease-in-out", // Smooth transition for hover effect
                          }}
                          onMouseEnter={(e) =>
                          (e.target.style.boxShadow =
                            "0 4px 8px rgba(0, 0, 0, 0.2)")
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.boxShadow = "none")
                          }
                          onClick={() => handleNavigation(category, "prev")}
                          disabled={currentIndex[category] === 0}
                        >
                          &lt;
                        </Button>
                        <Button
                          style={{
                            backgroundColor: "#90C54B",
                            marginRight: "1px",
                            transition: "box-shadow 0.3s ease-in-out", // Smooth transition for hover effect
                          }}
                          onMouseEnter={(e) =>
                          (e.target.style.boxShadow =
                            "0 4px 8px rgba(0, 0, 0, 0.2)")
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.boxShadow = "none")
                          }
                          onClick={() => handleNavigation(category, "next")}
                          disabled={
                            showAll[category] ||
                            currentIndex[category] >=
                            Math.ceil(apiData[category].length / 4) - 1
                          }
                        >
                          &gt;
                        </Button>
                        {!showAll[category] &&
                          currentIndex[category] ===
                          Math.ceil(apiData[category].length / 4) - 1 && (
                            <Button
                              style={{
                                backgroundColor: "#90C54B",
                                marginRight: "1px",
                                transition: "box-shadow 0.3s ease-in-out", // Smooth transition for hover effect
                              }}
                              onMouseEnter={(e) =>
                              (e.target.style.boxShadow =
                                "0 4px 8px rgba(0, 0, 0, 0.2)")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.boxShadow = "none")
                              }
                              onClick={() =>
                                handleShowMore(
                                  category === "Team-Members"
                                    ? "Team"
                                    : category
                                )
                              }
                            >
                              {">>"}
                            </Button>
                          )}
                      </div>
                    </div>
                    {renderCards(apiData[category], category)}
                  </div>
                ))}
              </Card>
            ) : (
              <div key={selectedCategory}>
                <div
                  className="d-flex justify-content-flex-start align-items-center"
                  style={{ marginTop: "4px" }}
                >
                  <h5 style={{ marginLeft: "16px" }}>
                    {(() => {
                      let label = selectedCategory.trim();

                      // Special case for "Team"
                      if (label.toLowerCase() === "team") {
                        return "TEAM MEMBERS";
                      }

                      label = label.replace(/[_-]/g, " ").trim();

                      if (!label.toLowerCase().endsWith("s")) {
                        label += "s";
                      }
                      return label.toUpperCase();
                    })()}
                  </h5>
                  <Button
                    // className="button-new positive"
                    style={{
                      width: "76px",
                      padding: "2px",
                      marginLeft: "8px",
                      marginRight: "16px", // Adjust this if needed
                      // marginBottom: "-0.5rem",
                      backgroundColor: "#90C54B",
                      transition: "box-shadow 0.3s ease-in-out", // Smooth transition for hover effect
                    }}
                    onMouseEnter={(e) =>
                    (e.target.style.boxShadow =
                      "0 4px 8px rgba(0, 0, 0, 0.2)")
                    }
                    onMouseLeave={(e) => (e.target.style.boxShadow = "none")}
                    onClick={() => handleListView(selectedCategory)}
                  >
                    List View
                  </Button>
                  {(selectedCategory === "Investor" || selectedCategory === "Agent") && <div>
                    <IconButton onClick={handleHotListStar}>
                      {hotlist ? (
                        <StarIcon
                          style={{ fontSize: "32px", color: "rgb(144, 197, 75)" }}
                        />
                      ) : (
                        <StarBorderIcon
                          style={{ fontSize: "32px", color: "black" }}
                        />
                      )}
                    </IconButton>
                  </div>}
                  {/* Alphabet Buttons */}
                  <div
                    className="d-flex flex-wrap"
                    style={{ marginLeft: "10px" }}
                  >
                    {alphabet.map((letter) => (
                      <Button
                        key={letter}
                        style={{
                          margin: "2px",
                          padding: "4px 8px",
                          backgroundColor:
                            selectedLetter === letter ? "#90C54B" : "#ccc",
                          color: "#fff",
                          border: "none",
                          transition: "0.3s",
                        }}
                        onClick={() => handleLetterClick(letter)}
                      >
                        {letter}
                      </Button>
                    ))}
                  </div>
                </div>
                {renderAllCards(contactsData, selectedCategory)}
              </div>
            )}
          </Container>
        </div>
      </div>
    </div>
  );
};

export default Contacts;
